import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import DatePickerComponent from "../../UI/DatePicker/DatepickerComponent";

import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import DownloadAttachment from "../../UI/DownloadAttachment/DownloadAttachment";

const PolicaOsiguranja = ({
  values,
  handleInputChange,
  handleDateChange,
  update,
  downloadAttachments,
  removeAttachment,
  handleMultiFileUpload,
  handleNumberInput,
  handleDecimalNumberInput
}) => {
  return (
    <div>
      <br></br>
      <InputComponent
        onChange={handleInputChange}
        value={values.nazivRevDrustva}
        id="nazivRevDrustva"
        name="nazivRevDrustva"
        controlLabel={
          "Naziv revizorskog društva / Ime i prezime samostalnog revizora"
        }
      />
    <div style={{backgroundColor: 'whitesmoke', padding: 16, marginBottom: 16}}>
      <InputComponent
        onChange={handleNumberInput}
        value={values.registarskiBroj}
        disabled={values.oib}
        name="registarskiBroj"
        id="regBroj"
        controlLabel={"Registarski broj"}
      />
      <InputComponent
        onChange={handleNumberInput}
        value={values.oib}
        disabled={values.registarskiBroj}
        name="oib"
        id="oibDrustva"
        controlLabel={"OIB"}
      />
      {!update ? <p style={{fontStyle: "italic", marginBottom: "0px"}}>Napomena: Nije moguće unijeti oba podatka u isto vrijeme.</p> : null}
    </div>
      <InputComponent
        onChange={handleNumberInput}
        value={values.brojPolice}
        name="brojPolice"
        id="brPolice"
        controlLabel={"Broj police osiguranja"}
      />
      <InputComponent
        onChange={handleDecimalNumberInput}
        value={values.premijaZaRazdoblje}
        name="premijaZaRazdoblje"
        id="premijaZaRazdoblje"
        controlLabel={"Premija za razdoblje (format ##,## EUR)"}
      />
      <InputComponent
        onChange={handleDecimalNumberInput}
        value={values.svotaPokrica}
        name="svotaPokrica"
        id="svotaPokrica"
        controlLabel={"Svota pokrića po štetnom događaju (format ##,## EUR)"}
      />
      <DatePickerComponent
        id="datIstekaPolice"
        handleDayClick={handleDateChange}
        controlLabel={"Datum isteka police osiguranja"}
        index={{ id: "datumIstekaPolice" }}
        width={"100%"}
        value={values.datumIstekaPolice}
      />
      <div style={{ padding: 4, width: "100%", backgroundColor: '#f8f9fa' , marginBottom: '16px'}}>
        <p style={{fontWeight: 500, margin: 0, padding: 0}}>Prilozi
        </p>
        <ul>
          <li>dopušteni formati: PDF</li>
          <li>maksimalna veličina datoteke - 10MB</li>
        </ul>
      </div>
      <label>Obavijest o nastalim promjenama tijekom osiguranja</label>
      <Upload
        id={"obavijestONastalimPromjenama"}
        beforeUpload={() => {
          return false;
        }}
        multiple
        accept={"application/pdf"}
        onChange={(file) =>
          handleMultiFileUpload(file, "obavijestONastalimPromjenama")
        }
        fileList={values.obavijestONastalimPromjenama}
      >
        <Button className={"upload-btn"} style={{ marginBottom: "16px" }}>
          <UploadOutlined /> Odaberite datoteku
        </Button>
      </Upload>
      <label>Dokument police osiguranja</label>
      <Upload
        id={"dokumentPoliceOsiguranja"}
        beforeUpload={() => {
          return false;
        }}
        accept={"application/pdf"}
        onChange={(file) =>
          handleMultiFileUpload(file, "dokumentPoliceOsiguranja")
        }
        multiple
        fileList={values.dokumentPoliceOsiguranja}
      >
        <Button className={"upload-btn"} style={{ marginBottom: "16px" }}>
          <UploadOutlined /> Odaberite datoteku
        </Button>
      </Upload>
      <InputComponent
        onChange={handleInputChange}
        value={values.napomena}
        name="napomena"
        id="napomena"
        controlLabel={"Napomena"}
        type="text"
      />

      {update &&
        (values.obavijestONastalimPromjenamaOld.length > 0 ||
          values.dokumentPoliceOsiguranjaOld.length > 0) && (
          <>
            <br></br>
            <span>
              <b>Prilozi učitani na unosu evidencije:</b>
            </span>
            <br></br>

            {values.obavijestONastalimPromjenamaOld.length > 0 && (
              <label> Obavijest o nastalim promjenama tijekom osiguranja</label>
            )}

            {values.obavijestONastalimPromjenamaOld.length > 0 &&
              values.obavijestONastalimPromjenamaOld.map((element) => {
                return (
                  <DownloadAttachment
                    id={element.idPredPolja}
                    downloadAttachments={downloadAttachments}
                    removeAttachment={removeAttachment}
                    contentType={element.contentType}
                    fileName={element.fileName}
                    group={"obavijestONastalimPromjenamaOld"}
                  />
                );
              })}

            {values.dokumentPoliceOsiguranjaOld.length > 0 && (
              <label> Dokument police osiguranja</label>
            )}
            {values.dokumentPoliceOsiguranjaOld.length > 0 &&
              values.dokumentPoliceOsiguranjaOld.map((element) => {
                return (
                  <DownloadAttachment
                    id={element.idPredPolja}
                    downloadAttachments={downloadAttachments}
                    removeAttachment={removeAttachment}
                    contentType={element.contentType}
                    fileName={element.fileName}
                    group={"dokumentPoliceOsiguranjaOld"}
                    label={"Dokument police osiguranja"}
                  />
                );
              })}
          </>
        )}
    </div>
  );
};

export default PolicaOsiguranja;
